import * as i0 from '@angular/core';
import { Directive, Input, Component, ContentChildren, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import focusTrap from 'focus-trap';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

class CustomizeTemplate {
    constructor(template) {
        this.template = template;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CustomizeTemplate, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.11", type: CustomizeTemplate, selector: "[ngTemplate]", inputs: { type: "type", name: ["ngTemplate", "name"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CustomizeTemplate, decorators: [{
            type: Directive,
            args: [{
                    selector: '[ngTemplate]',
                    host: {}
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }], propDecorators: { type: [{
                type: Input
            }], name: [{
                type: Input,
                args: ['ngTemplate']
            }] } });
class ComplexPanelComponent {
    constructor(el, render) {
        this.el = el;
        this.render = render;
        this.role = "dialog";
        this.style = '';
        this.styleClass = '';
        this.complexPanelId = '';
        this.escDownSubject = new Subject();
    }
    ngAfterContentInit() {
        if (!this.complexPanelId) {
            this.complexPanelId =
                "cp" +
                    String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
                    String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
                    Date.now();
        }
        if (this.templates.length) {
            this.templateMap = {};
        }
        this.templates.forEach((item) => {
            this.templateMap[item.name] = item.template;
        });
    }
    onKeydownComplex(event) {
        let keyCode = event.keyCode;
        switch (keyCode) {
            case 9:
                const dialog = document.getElementById(this.complexPanelId)
                    ? document.getElementById(this.complexPanelId)
                    : this.el.nativeElement.querySelector("#" + this.complexPanelId);
                this.focusTrapEle = focusTrap(dialog, {
                    clickOutsideDeactivates: true,
                    escapeDeactivates: true,
                });
                this.focusTrapEle.activate();
                break;
            case 27:
                this.escDownSubject.next(event);
        }
    }
    getKeydownSubject() {
        return this.escDownSubject;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ComplexPanelComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: ComplexPanelComponent, selector: "ap-complex-panel", inputs: { role: "role", style: "style", styleClass: "styleClass", complexPanelId: "complexPanelId" }, queries: [{ propertyName: "templates", predicate: CustomizeTemplate }], ngImport: i0, template: "<div class=\"ap-complex-panel {{styleClass}}\" [style]=\"style\" [attr.role]=\"role\" [attr.id]=\"complexPanelId\" (keydown)=\"onKeydownComplex($event)\">\n    <div class=\"ap-complex-panel-header\" *ngIf=\"templateMap && templateMap['header']\">\n        <ng-container *ngTemplateOutlet=\"templateMap['header']\"></ng-container>   \n    </div>\n    <ng-content></ng-content>\n    <div class=\"ap-complex-panel-footer\" *ngIf=\"templateMap && templateMap['footer']\">\n        <ng-container *ngTemplateOutlet=\"templateMap['footer']\"></ng-container>\n    </div> \n</div>", styles: [".ap-complex-panel{width:14rem;padding:var(--spacing-4);border-radius:var(--border-radius-3);box-shadow:var(--box-shadow-3);background-color:var(--color-background-container)}.ap-complex-panel .ap-complex-panel-header{display:flex;justify-content:space-between;margin-bottom:var(--spacing-4)}.ap-complex-panel .ap-complex-panel-footer{display:flex;justify-content:flex-end;margin-top:var(--spacing-4)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ComplexPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ap-complex-panel', template: "<div class=\"ap-complex-panel {{styleClass}}\" [style]=\"style\" [attr.role]=\"role\" [attr.id]=\"complexPanelId\" (keydown)=\"onKeydownComplex($event)\">\n    <div class=\"ap-complex-panel-header\" *ngIf=\"templateMap && templateMap['header']\">\n        <ng-container *ngTemplateOutlet=\"templateMap['header']\"></ng-container>   \n    </div>\n    <ng-content></ng-content>\n    <div class=\"ap-complex-panel-footer\" *ngIf=\"templateMap && templateMap['footer']\">\n        <ng-container *ngTemplateOutlet=\"templateMap['footer']\"></ng-container>\n    </div> \n</div>", styles: [".ap-complex-panel{width:14rem;padding:var(--spacing-4);border-radius:var(--border-radius-3);box-shadow:var(--box-shadow-3);background-color:var(--color-background-container)}.ap-complex-panel .ap-complex-panel-header{display:flex;justify-content:space-between;margin-bottom:var(--spacing-4)}.ap-complex-panel .ap-complex-panel-footer{display:flex;justify-content:flex-end;margin-top:var(--spacing-4)}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { role: [{
                type: Input
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], complexPanelId: [{
                type: Input
            }], templates: [{
                type: ContentChildren,
                args: [CustomizeTemplate]
            }] } });

class ComplexPanelModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ComplexPanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: ComplexPanelModule, declarations: [ComplexPanelComponent,
            CustomizeTemplate], imports: [CommonModule,
            FormsModule], exports: [ComplexPanelComponent,
            CustomizeTemplate] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ComplexPanelModule, imports: [CommonModule,
            FormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: ComplexPanelModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule
                    ],
                    exports: [
                        ComplexPanelComponent,
                        CustomizeTemplate
                    ],
                    declarations: [
                        ComplexPanelComponent,
                        CustomizeTemplate
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ComplexPanelComponent, ComplexPanelModule, CustomizeTemplate };
